module.exports = __webpack_public_path__ + "static/media/Gladiator.9bc7980f.jpg";